/**
 * A form similar to FormColumn, but uses a DDM with 2 columns
 */
import { Controller, useFormContext } from 'react-hook-form';

import DoubleColumnSelect from './DoubleColumnSelect';
import { getSimplePrescriptionValuesArray } from '@utils/utils';
import { MenuItem, Select } from '@mui/material';
import ArrowDown from '@images/svg-icons/arrowDown.svg';

interface EyeProps {
    enabled: boolean;
    name: string;
    defaultValue?: string;
    values: string[] | number[];
}

interface DropdownProps {
    attribute: string;
    label: string;
    left?: EyeProps;
    right?: EyeProps;
}

const menuOptions = {
    PaperProps: {
        style: {
            maxHeight: 220, // set a maximum height for the menu
        },
    },
};

const FormDoubleColumn = ({ attribute, label, left, right }: DropdownProps) => {
    const { register, control } = useFormContext();

    console.log('left values: ', left?.values);

    console.log('right values: ', right?.values);

    //returns true if contains both strictly negative and strictly positive values, false otherwise
    const hasBothValuesRange = values => {
        if (!values) return false;
        var hasNeg = false;
        var hasPos = false;
        for (let i = 0; i < values.length; i++) {
            if (parseFloat(values[i]) < 0) hasNeg = true;
            else if (parseFloat(values[i]) > 0) hasPos = true;
            if (hasNeg && hasPos) return true;
        }
        return false;
    };

    return (
        <>
            {(right?.values?.length || left?.values?.length) && (
                <div
                    className={`${attribute}-column param-column ${
                        right?.values.length === 1 && left?.values.length === 1
                            ? 'single-value'
                            : ''
                    }`}
                >
                    <div className={`param-label ${attribute}-label`}>
                        <label>{label}</label>
                    </div>

                    {!!right && (
                        <div className={`presc-param-select ${attribute}-select right`}>
                            {right?.values.length === 1 ? (
                                <>
                                    <input
                                        type="hidden"
                                        {...register(right?.name)}
                                        value={right?.values[0]}
                                    />
                                    {right?.values[0]}
                                </>
                            ) : (
                                <Controller
                                    name={right?.name}
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value } }) =>
                                        hasBothValuesRange(right?.values) ? (
                                            <DoubleColumnSelect
                                                aria-label={`Right eye ${attribute}`}
                                                name={right?.name}
                                                value={value}
                                                disabled={!right?.enabled}
                                                register={register(right?.name)}
                                                onChange={onChange}
                                                options={getSimplePrescriptionValuesArray(
                                                    right?.values,
                                                    2
                                                ).map((e, key) => {
                                                    return (
                                                        <option key={key} value={e.value}>
                                                            {e.name}
                                                        </option>
                                                    );
                                                })}
                                            />
                                        ) : (
                                            <Select
                                                aria-label={`Right eye ${attribute}`}
                                                disabled={!right?.enabled}
                                                value={value}
                                                onChange={onChange}
                                                defaultValue={right?.defaultValue || ''}
                                                className={`param-select`}
                                                IconComponent={props => <ArrowDown {...props} />}
                                                MenuProps={menuOptions}
                                            >
                                                {right?.values.map((v: string | number) => (
                                                    <MenuItem key={v} value={v}>
                                                        {v}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )
                                    }
                                />
                            )}
                        </div>
                    )}

                    {!!left && (
                        <div className={`presc-param-select ${attribute}-select left`}>
                            {left?.values.length === 1 ? (
                                <>
                                    <input
                                        type="hidden"
                                        {...register(left?.name)}
                                        value={left?.values[0]}
                                    />
                                    {left?.values[0]}
                                </>
                            ) : (
                                <Controller
                                    name={left?.name}
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value } }) =>
                                        hasBothValuesRange(left?.values) ? (
                                            <DoubleColumnSelect
                                                aria-label={`Left eye ${attribute}`}
                                                name={left?.name}
                                                value={value}
                                                disabled={!left?.enabled}
                                                register={register(left?.name)}
                                                onChange={onChange}
                                                options={getSimplePrescriptionValuesArray(
                                                    right?.values,
                                                    2
                                                ).map((e, key) => {
                                                    return (
                                                        <option key={key} value={e.value}>
                                                            {e.name}
                                                        </option>
                                                    );
                                                })}
                                            />
                                        ) : (
                                            <Select
                                                aria-label={`Left eye ${attribute}`}
                                                disabled={!left?.enabled}
                                                value={value}
                                                onChange={onChange}
                                                defaultValue={left?.defaultValue || ''}
                                                className={`param-select`}
                                                IconComponent={props => <ArrowDown {...props} />}
                                                MenuProps={menuOptions}
                                            >
                                                {left?.values.map((v: string | number) => (
                                                    <MenuItem key={v} value={v}>
                                                        {v}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )
                                    }
                                />
                            )}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default FormDoubleColumn;
